import { useContext } from 'react';
import { TogglesContext } from './toggles.provider';
import { Hook } from './toggles.types';

export const useToggles: Hook = () => {
  const context = useContext(TogglesContext);
  if (context) {
    return context;
  }
  throw new Error('O contexto de Toggles ainda não está pronto');
};
